var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9524 15.2601C11.3265 17.5118 7.36183 17.2076 5.11012 14.5817C2.85842 11.9557 3.16262 7.99107 5.78858 5.73936C8.41454 3.48766 12.3792 3.79186 14.6309 6.41782C16.8826 9.04378 16.5784 13.0084 13.9524 15.2601ZM6.35815 6.4036C4.09974 8.34014 3.83782 11.7537 5.77436 14.0121C7.71091 16.2705 11.1244 16.5324 13.3829 14.5959C15.6413 12.6593 15.9032 9.2458 13.9666 6.98739C12.0301 4.72898 8.61657 4.46706 6.35815 6.4036Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2624 9.88291L8.60543 12.1612C8.42387 12.3169 8.1442 12.2954 7.98852 12.1139C7.83284 11.9323 7.8543 11.6526 8.03585 11.497L10.6928 9.21867C10.8744 9.06299 11.154 9.08444 11.3097 9.266C11.4654 9.44756 11.4439 9.72723 11.2624 9.88291Z",
    fill: "#858585"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5158 11.9708C11.4317 12.043 11.321 12.0841 11.1976 12.0746C10.959 12.0563 10.7768 11.8438 10.7951 11.6053L10.951 9.57358L8.91929 9.41769C8.68075 9.39939 8.49849 9.18683 8.51679 8.9483C8.5351 8.70976 8.74765 8.5275 8.98619 8.5458L11.4538 8.73514C11.6923 8.75344 11.8746 8.966 11.8563 9.20453L11.667 11.6722C11.6575 11.7955 11.5999 11.8987 11.5158 11.9708Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagonal);
export default __webpack_public_path__ + "static/media/arrow-diagonal.f241c230696022a99a93140ff7547ddd.svg";
export { ForwardRef as ReactComponent };